import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { getProjectPortfolio } from "../../../api/projectApi";

const LaborAnalysisSelect = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const loadProjects = async () => {
      try {
        setIsLoading(true);
        const projects = await getProjectPortfolio();
        const opts = (projects || []).map((p) => ({
          value: p.id,
          label: `${p.cipher_pilot ? p.cipher_pilot + " — " : ""}${
            p.name || "Без названия"
          }`,
        }));
        setOptions(opts);
      } catch (e) {
        setError(e?.message || "Не удалось загрузить проекты");
      } finally {
        setIsLoading(false);
      }
    };
    loadProjects();
  }, []);

  const handleProjectSelect = (opt) => {
    if (!opt) return;
    navigate(`/projects/labor-analysis/${opt.value}`);
  };

  return (
    <div style={{ maxWidth: 720, margin: "40px auto", padding: "0 16px" }}>
      <h2 style={{ marginBottom: 16 }}>Анализ трудозатрат</h2>
      <p style={{ color: "#6c757d", marginBottom: 16 }}>
        Выберите проект для просмотра анализа трудозатрат
      </p>
      {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}
      <Select
        isLoading={isLoading}
        options={options}
        placeholder="Начните вводить название или шифр проекта..."
        onChange={handleProjectSelect}
        isClearable
      />
    </div>
  );
};

export default LaborAnalysisSelect;
